import { createSelector } from 'reselect';
import { get, map } from 'lodash';

import {
    DMARC_POLICY_INHERITED_NONE,
} from '../../common/constants/dmarc-policy-values';
import { DOMAIN_HIERARCHY_PARENT, DOMAIN_HIERARCHY_SUBDOMAIN } from '../../common/constants/definitions';
import { suggestedDomainsSelector } from '../../common/selectors/suggested-domains-selectors';
import { unclaimedParentDomainsWithCountsSelector } from '../../common/selectors/unclaimed-domains-with-counts-selectors';

export const discoveredDomainHierarchyParamSelector = props => {
    const urlParam = get( props, 'location.search', '' );

    if( urlParam.includes( DOMAIN_HIERARCHY_SUBDOMAIN ) ){
        return DOMAIN_HIERARCHY_SUBDOMAIN;
    }
    else{
        return DOMAIN_HIERARCHY_PARENT;
    }
};


export const discoveredParentDomainsTableDataSelector = createSelector(
    unclaimedParentDomainsWithCountsSelector,
    ( unclaimedParentDomains ) => {
        return map( unclaimedParentDomains, domain => {
            return {
                dateDiscovered: domain.dateDiscovered,
                domainName: domain.domainName,
                registrant: domain.registrant,
                registrantEmail: domain.registrantEmail,
                totalVolume: domain.totalMailCount,
            };
        } );
    }
);

export const discoveredSubdomainsTableDataSelector = createSelector(
    suggestedDomainsSelector,
    ( suggestedDomains ) => {
        return map( suggestedDomains, domain => {
            const dmarcPolicy = get( domain, 'dmarc.statusPolicy', null );

            return {
                dmarcPolicy,
                dmarcPolicyInherited: get( domain, 'dmarc.policyInherited', DMARC_POLICY_INHERITED_NONE ),
                domainName: domain.domainName,
                totalVolume: domain.totalMailCount,
            };
        } );
    }
);

